import type { FunctionComponent } from 'react'
import { useEffect, useState } from 'react'
import CopilotIcon from './ui/icons/CopilotIcon'
import { openExternalLink } from '../utils/openExternalLink'
import { Button } from '@playbooks/ui/components/button'

/**
 * "Open Copilot" button component.
 * @story User Story 7456: AI copilot: real-time filling out of AC: PoC pt.1
 */
const CopilotButton: FunctionComponent = () => {
  const [isFeatureEnabled, setIsFeatureEnabled] = useState(false)

  // Check if the Copilot button feature is enabled in LaunchDarkly
  useEffect(() => {
    async function checkFeatureEnabled() {
      if (!(window as any).__ldClient) return false
      const isEnabled = await (window as any).__ldClient.isFlagEnabled('ac-copilot')
      setIsFeatureEnabled(isEnabled)
    }

    checkFeatureEnabled()
  }, [])

  if (!isInFomContext() || !isFeatureEnabled) {
    return null
  }

  return (
    <Button variant="ghost" data-testid="copilotBtn" onClick={openCopilotPage} type="button">
      <CopilotIcon color="#EA5B0C" />
    </Button>
  )
}

/**
 * Check whether the component is in the context of a FOM site (e.g. *.linkando.com)
 * and therefore can use Collios cookie authorization.
 */
function isInFomContext() {
  return !!(window as any).environment?.endpoints?.service
}

/**
 * Open the Copilot page in a new tab with auto-login.
 */
async function openCopilotPage() {
  const copilotLink = await getCopilotPageLink()
  await openExternalLink(copilotLink)
}

/**
 * Get the Copilot page auto-login link from the backend.
 */
async function getCopilotPageLink() {
  const urlParams = new URLSearchParams(window.location.search)
  const isMeeting = window.location.href.includes('meeting')
  const functionUrl =
    `${(window as any).environment.endpoints.service}/getCopilotLink` +
    `?${isMeeting ? 'meeting-id' : 'project-id'}=${urlParams.get('id')}` +
    `&tenant-code=${(window as any).constants.tenantCode}`
  const targetUrl = `authProxy?url=${encodeURIComponent(functionUrl)}`
  const response = await fetch(targetUrl)
  return await response.text()
}

export default CopilotButton
